export function Incards() {
  return (
    <div className="incards">
      <h1>Teste</h1>
    </div>
  );
}
